import { useTranslation } from 'react-i18next';

import { ArrowEnterSolid, ArrowNarrowDownOutline, ArrowNarrowUpOutline, HStack, ModalFooter, Text } from '@bonusly/design-system';

import { Key } from '../Keyboard';
import { useSearchContext } from './context';

export const SearchFooter = () => {
	const { t } = useTranslation('common');

	if (!useSearchContext().hasAnyRecords) {
		return null;
	}

	return (
		<ModalFooter backgroundColor="bg.subtle" borderBottomRadius="md" justifyContent="flex-start" p={3}>
			<HStack color="text.softest" fontSize="xl" fontWeight="medium" spacing={1}>
				<Key icon={<ArrowNarrowUpOutline size="xs" />} />
				<Key icon={<ArrowNarrowDownOutline size="xs" />} />
				<Text as="span" fontSize="md">
					{t('navigate')}
				</Text>
			</HStack>

			<HStack color="text.softest" fontSize="xl" fontWeight="medium" ml={6} spacing={1}>
				<Key icon={<ArrowEnterSolid size="xs" />} />
				<Text as="span" fontSize="md">
					{t('go')}
				</Text>
			</HStack>
		</ModalFooter>
	);
};
